module.exports = __webpack_public_path__ + "static/stu-profile-ba584cd1cbd1600016e902700ae288cf.png";